<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-account-key</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="apikeys"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="[v => !!v || 'Item is required']"
                        label="Usuario ID"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVA CLAVE</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="[v => !!v || 'Item is required']"
                        label="Usuario ID"
                        required
                        outlined shaped
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.expire_unit"
                        :items="['minute', 'hour', 'day', 'month', 'year', 'false']"
                        :rules="[v => !!v || 'Item is required']"
                        label="Unidad de Medida"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.expire_time" label="Tiempo para Expirar" type="number"
                        :counter="50" required></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <!--<v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>-->
      <v-icon
        small
        @click="copy_key(item)"
      >
        mdi-content-copy
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-key-remove
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',

    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    md_schema: process.env.VUE_MD_SCHEMA,
    dialog: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Actions', value: 'action', sortable: false },
      { text: 'Usuario ID', value: 'ApiUser_id' },
      { text: 'Clave Estado', value: 'ApiKey_Status' },
      { text: 'Clave Inicio', value: 'ApiKey_StartTime' },
      { text: 'Clave Fin', value: 'ApiKey_ExpireTime' },
      //{ text: 'Clave ID', value: 'ApiKey_id' },
    ],

    
    apikeys: [],
    users: [],
    editedIndex: -1,
    editedItem: {
      ApiUser_id: '',
      expire_unit: '',
      expire_time: ''
    },
    defaultItem: {
      ApiUser_id: '',
      expire_unit: '',
      expire_time: ''
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 50) || 'Rol ID debe tener menos de 30 caracteres'
    ],
    procidRules: [
      v => !!v || 'Usaurio ID es requerido',
      v => (v && v.length <= 50) || 'Usaurio ID debe tener menos de 30 caracteres'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Permiso' : 'Editar Permiso'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.$store.commit('updateTitle', 'Administración de Claves')
    this.initialize()
  },

  methods: {
    initialize () {
      axios.get(this.api_tool_url + '/select/table/' + this.md_schema + '/v_apikey', this.config)
        .then(response => {
          this.apikeys = response.data.ResultRows
        })
        .catch(error => {
          this.apikeys = []
          alert(error.response.data.message)
        })

      axios.post(this.api_tool_url + '/get_users', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.users.push(data.ApiUser_id)
          })
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.apikeys.indexOf(item)
      this.editedItem = Object.assign({}, item)
      console.log(this.users)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.apikeys.indexOf(item)
      this.editedItem = Object.assign({}, item)
      console.log(this.users)
      this.dialog = true
    },

    deleteItem (item) {
      if (item.ApiKey_Status == 'Activa'){
        const index = this.apikeys.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteApiKey(index)
      }
      else {
        alert("La clave no esta activa")
      }
    },

    deleteApiKey (index) {
      let apikeysTmp = this.apikeys[index]
      delete apikeysTmp.ApiKey_EndDt
      axios.get(this.api_tool_url + '/revoke_apikey?key=' + apikeysTmp.ApiKey_id + "&user=" + apikeysTmp.ApiUser_id, this.config)
        .then(response => {
          axios.get(this.api_tool_url + '/select/table/' + this.md_schema + '/v_apikey', this.config)
            .then(response => {
              this.apikeys = response.data.ResultRows
            })
            .catch(error => {
              this.apikeys = []
              alert(error.response.data.message)
            })
          this.close()
        })
        .catch(error => {
          // this.apikeys = []
          alert(error.response.data.message)
        })
    },

    copy_key(item) {
      this.$copyText(item.ApiKey_id).then(function (e) {
          alert('Clave Copiada')
        }, function (e) {
          alert('No se pudo copiar la clave')
        })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_rolerights', this.editedItem, this.config)
          .then(response => {
            Object.assign(this.rolerights[this.editedIndex], response.data[0])
            this.close()
          })
          .catch(error => {
            this.rolerights = []
            alert(error.response.data.message)
          })
      } else {
        let apikeysTmp = this.editedItem
        axios.get(this.api_tool_url + '/gen_apikey?' + "user_id=" + apikeysTmp.ApiUser_id + "&expire_unit=" + apikeysTmp.expire_unit + "&expire_time=" + apikeysTmp.expire_time, this.config)
          .then(response => {
            axios.get(this.api_tool_url + '/select/table/' + this.md_schema + '/v_apikey', this.config)
            .then(response => {
              this.apikeys = response.data.ResultRows
            })
            .catch(error => {
              this.apikeys = []
              alert(error.response.data.message)
            })
            this.close()
          })
          .catch(error => {
            this.apikeys = []
            alert(error.response.data.message)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ApiKeyGrid.vue